// extracted by mini-css-extract-plugin
export default {"error-message":"Input_error-message__H5ou1"};